import { useTranslation } from 'react-i18next';
import { Logo } from './Logo';
import { LangSwitcher } from './LangSwitcher';
import { APP_URL } from '@/config';
import { APP_VERSION } from '@/config';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-clay-300/10 bg-clay-950">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-5 py-12 sm:flex-row sm:justify-between">
        <div className="text-center sm:text-left">
          <Logo />
          <p className="mt-3 max-w-xs text-sm text-clay-400">{t('footer.tagline')}</p>
        </div>

        <div className="flex flex-col items-center gap-3 sm:items-end">
          <a
            href={APP_URL}
            className="text-sm font-medium text-amber-glow transition hover:underline"
          >
            {t('nav.explore')}
          </a>
          <LangSwitcher />
          <p className="text-xs text-clay-500">{t('footer.made')}</p>
        </div>
      </div>

      <div className="border-t border-clay-300/5">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-5 py-5 text-xs text-clay-500 sm:flex-row">
          <span>
            © {new Date().getFullYear()} Bestigium. {t('footer.rights')}
          </span>
          {/* Versión visible (regla 3 vitta_developer) */}
          <span className="font-mono text-clay-600">v{APP_VERSION}</span>
        </div>
      </div>
    </footer>
  );
}
